"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfinityDependencies = void 0;
var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var InfinityDependencies = exports.InfinityDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createInfinity: _factoriesAny.createInfinity
};